/// <reference path="session.service.ts" />
/// <reference path="../factories/httphelper.factory.ts" />
/// <reference path="../objects/interfaces/icompositionservice.ts" />
/// <reference path="../factories/blocks.logger.factory.ts" />
/// <reference path="../factories/blocks.exception.factory.ts" />

module App.Services {
    export class CompositionService implements Interfaces.ICompositionService {
        static serviceId = 'compositionService';

        static $inject = [
            '$rootScope',
            '$q',
            Blocks.LoggerService.factoryId,
            Blocks.ExceptionService.factoryId,
            App.HttpHelper.factoryId,
            App.Services.SessionService.serviceId
        ]

        constructor(private $rootScope: Interfaces.IAppRootScope,
            private $q: ng.IQService,
            private logger: Blocks.Interfaces.ILoggerService,
            private exception: Blocks.IExceptionService,
            private httpHelper: IHttpHelper,
            private session: App.Interfaces.ISessionService) {
        }

        $get = () => {
            return this
        }

        handleCompositionRequest = (key: string, value: object): ng.IPromise<App.Classes.ICompositionResult> => {
            if (this.session.composition == null) {
                this.session.composition = new Classes.Composition()
            }

            let tempSession = this.session.composition
            tempSession[key] = value

            this.session.composition = tempSession

            return this.doCompositionRequest(tempSession)
        }

        getFormInformation = (): ng.IPromise<string> => {
            let deferred = this.$q.defer<string>()
            let method = 'POST'

            this.httpHelper.makeCall<string>(Constants.websiteUrlCalls.getFormInfo, method, { Id: Variables.currentPageId }, { 'AmegaPlannerFranchise': App.Variables.websiteId })
                .then((result) => {
                    deferred.resolve(result)
                })
                .catch((err) => {
                    deferred.reject(err.message)
                })

            return deferred.promise
        }

        getReplacementVehicleTexts = (settlementId: string): ng.IPromise<string> =>
        {
            let deferred = this.$q.defer<string>()

            let method = 'POST'
            this.httpHelper.makeCall<string>(Constants.websiteUrlCalls.getReplacementVehicleTexts, method, { Id: settlementId }, { 'AmegaPlannerFranchise': App.Variables.websiteId })
                .then((result) =>
                {
                    deferred.resolve(result)
                })
                .catch((err) =>
                {
                    deferred.reject(err.message)
                })

            return deferred.promise
        }

        doCompositionRequest = (postComposition: Classes.IComposition): ng.IPromise<App.Classes.ICompositionResult> => {
            let deffered = this.$q.defer<App.Classes.ICompositionResult>()

            postComposition.pipeline = App.Variables.configuratorType
            postComposition.allowColorChange = App.Variables.allowColorChange

            let method = 'POST'
            this.httpHelper.makeCall<App.Classes.ICompositionResult>(Constants.websiteUrlCalls.setState, method, postComposition, { 'AmegaPlannerFranchise': App.Variables.websiteId }).then(
                (result) => {
                    if (!result.error && result.composition != null) {
                        result.composition.privacyCheck = false
                        this.session.composition = result.composition
                    }

                    try {
                        let data = <any>result
                        if (data.status == 500) {
                            deffered.reject('Error saving data')
                        }    
                    } catch (e) {
                    }

                    deffered.resolve(result)
                }).catch((err) => {
                    deffered.reject(err.message)
                })

            return deffered.promise
        }

    }

    app.service(CompositionService.serviceId, CompositionService)
}